import { oidcEarlyInit } from "oidc-spa/entrypoint";

const { shouldLoadApp } = oidcEarlyInit({
  freezeFetch: true,
  freezeXMLHttpRequest: true,
});

if (shouldLoadApp) {
  import("./main.lazy");
}
